import { Label as FluentLabel } from "@fluentui/web-components";
/**
 * Label
 * @summary A Fabric UI Label component that provides a customizable label element, supporting different sizes, weights, and required state indication.
 *
 * @example
 * ```html
 * <fabric-label size="large" weight="semibold" required>
 *   Username
 *   <span slot="asterisk">*</span>
 * </fabric-label>
 * ```
 *
 * @attr {LabelSize} size - Specifies font size of a label. Can be 'small', 'medium', or 'large'.
 * @attr {LabelWeight} weight - Specifies font weight of a label. Can be 'regular' or 'semibold'.
 * @attr {boolean} disabled - Specifies styles for label when associated input is disabled. Defaults to false.
 * @attr {boolean} required - Specifies styles for label when associated input is a required field. Defaults to false.
 *
 * @prop {LabelSize} size - Specifies font size of a label. Can be 'small', 'medium', or 'large'.
 * @prop {LabelWeight} weight - Specifies font weight of a label. Can be 'regular' or 'semibold'.
 * @prop {boolean} disabled - Specifies styles for label when associated input is disabled. Defaults to false.
 * @prop {boolean} required - Specifies styles for label when associated input is a required field. Defaults to false.
 *
 * @slot - The default slot for the label's text.
 * @slot asterisk - The slot for the required field indicator, an asterisk by default.
 *
 * @csspart asterisk - The part representing the required field indicator.
 *
 * @extends FluentLabel
 * @tagname fabric-label
 * @public
 */
export class Label extends FluentLabel {
}
//# sourceMappingURL=label.js.map